import React, { Component } from "react";
import Edit from "../assets/edit.svg";
import deletee from "../assets/delete.svg";
import tick from "../assets/tick-active.svg";
import reporticon from "../assets/report.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default class EventActionButtons extends Component {
  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: "100%",
        }}
      >
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 200, hide: 200 }}
          overlay={
            <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
              فعال سازی نهایی
            </Tooltip>
          }
        >
          <div
            style={{
              cursor: "pointer",
              userSelect: "none",
              marginRight: "0px",
            }}
            onClick={() => this.props.onActive(this.props.value)}
          >
            <img
              src={tick}
              alt=""
              style={{ objectFit: "contain", height: "25px" }}
            />
          </div>
        </OverlayTrigger>

        <OverlayTrigger
          placement="bottom"
          delay={{ show: 200, hide: 200 }}
          overlay={
            <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
              گزارش رویداد
            </Tooltip>
          }
        >
          <div
            style={{
              cursor: "pointer",
              userSelect: "none",
              marginRight: "20px",
            }}
            onClick={() => this.props.onReport(this.props.value)}
          >
            <img
              src={reporticon}
              alt=""
              style={{ objectFit: "contain", height: "25px" }}
            />
          </div>
        </OverlayTrigger>

        <OverlayTrigger
          placement="bottom"
          delay={{ show: 200, hide: 200 }}
          overlay={
            <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
              ویرایش
            </Tooltip>
          }
        >
          <div
            style={{
              cursor: "pointer",
              userSelect: "none",
              marginRight: "20px",
            }}
            onClick={() => this.props.editItem(this.props.value)}
          >
            <img
              src={Edit}
              alt=""
              style={{ objectFit: "contain", height: "20px" }}
            />
          </div>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 200, hide: 200 }}
          overlay={
            <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
              حذف
            </Tooltip>
          }
        >
          <div
            style={{
              cursor: "pointer",
              userSelect: "none",
              marginRight: "20px",
            }}
            onClick={() => this.props.onDelete(this.props.value)}
          >
            <img
              src={deletee}
              alt=""
              style={{ objectFit: "contain", height: "25px" }}
            />
          </div>
        </OverlayTrigger>
      </div>
    );
  }
}
